import { createFileRoute, notFound, redirect } from '@tanstack/react-router';
import { isUuid } from '@leanin/shared';
import { requirePlatformRole } from '@/lib/route-guards';
import { LearningTrackAdminView } from '@/components/learning-tracks/LearningTrackAdminView';

export const Route = createFileRoute(
  '/_authed/admin/resources/learning-tracks/$trackId/',
)({
  beforeLoad: async ({ params, context }) => {
    if (!isUuid(params.trackId)) throw notFound();
    await requirePlatformRole(context, {
      role: 'admin',
      bounceTo: () =>
        redirect({
          to: '/resources/learning-tracks/$trackId',
          params: { trackId: params.trackId },
        }),
    });
  },
  component: LearningTrackAdminPage,
});

function LearningTrackAdminPage() {
  const { trackId } = Route.useParams();
  return <LearningTrackAdminView trackId={trackId} />;
}
